import React from "react";
import { Controller } from "react-hook-form";
import { Autocomplete, MenuItem, TextField } from "@mui/material";
import { DropdownAllInvoicesProps } from "./ModalAddSold";
import { InvoiceEntity } from "../../../types";

export const DropdownAllInvoices: React.FC<DropdownAllInvoicesProps> = ({
  name,
  control,
  label,
  user,
  setValue1,
  setInvoice,
  ids,
  nrFacturi,
  locations,
  sume,
  dates,
}) => {
  // Create invoice options from the provided data
  const invoiceOptions = nrFacturi.map((nr, index) => ({
    id: ids[index],
    facturaNumber: nr,
    location: locations[index],
    amount: sume[index],
    date: dates[index],
  }));

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value, ...props },
        fieldState: { error },
      }) => (
        <Autocomplete
          {...props}
          options={invoiceOptions}
          getOptionLabel={(option) =>
            typeof option === "string"
              ? option
              : `${option.facturaNumber} - ${option.location} - ${option.amount} RON - ${option.date}`
          }
          isOptionEqualToValue={(option, value) => {
            if (typeof value === "string") {
              return option.facturaNumber === value;
            }
            return option.facturaNumber === value?.facturaNumber;
          }}
          value={value}
          onChange={(_, data) => {
            // When selecting an invoice, update related form fields
            if (data) {
              const selectedInvoice = data as (typeof invoiceOptions)[0];
              setValue1("locationValue", selectedInvoice.location);
              setValue1("nrFactura", selectedInvoice.facturaNumber);

              // Create an invoice entity for tracking the selected invoice
              const invoiceEntity: InvoiceEntity = {
                id: selectedInvoice.id,
                nrFactura: selectedInvoice.facturaNumber,
                location: selectedInvoice.location,
                price: parseFloat(selectedInvoice.amount),
                created_date: selectedInvoice.date,
              };

              setInvoice(invoiceEntity);
              onChange(selectedInvoice.facturaNumber);
            } else {
              // Clear fields when no invoice is selected
              setValue1("locationValue", null);
              setValue1("nrFactura", null);
              setInvoice(null);
              onChange(null);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              error={!!error}
              helperText={error ? error.message : null}
              size="small"
              sx={{
                "& .MuiInputBase-input": {
                  color: "black",
                  fontFamily: "Catesque",
                },
                "& .MuiInputLabel-root": {
                  color: "black",
                  fontFamily: "Catesque",
                  fontSize: "18px",
                  "&.Mui-focused fieldset": {
                    borderColor: "#0054a6",
                  },
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#0054a6",
                  },
                  "&:hover fieldset": {
                    borderColor: "#0054a6",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#0054a6",
                  },
                },
                "& .MuiAutocomplete-endAdornment": {
                  "& .MuiButtonBase-root": {
                    color: "#0054a6",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  },
                },
                userSelect: "none",
              }}
            />
          )}
          renderOption={(props, option) => (
            <MenuItem
              {...props}
              sx={{ fontFamily: "Catesque", fontSize: "16px" }}
            >
              {`${option.facturaNumber} - ${option.location} - ${option.amount} RON - ${option.date}`}
            </MenuItem>
          )}
        />
      )}
    />
  );
};
